import { Checkbox, CheckboxProps, FormControlLabel, FormGroup, Grid } from "@mui/material";
import { KaColumn } from "../../../Typings/TableColumn";
import Modal from "../../Modal/Modal";

export default function TableColumnSelection({
  columns,
  onCheckboxChange,
  isOpen,
  handleModalClose,
}: {
  columns: KaColumn[];
  onCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  isOpen: boolean;
  handleModalClose: () => void;
}) {
  const togglableColumns = filterColumns(columns);

  const columnSize = togglableColumns.length > 20 ? 4 : togglableColumns.length > 10 ? 6 : 12;

  return (
    <Modal
      title="Edit Table Columns"
      size="md"
      content={
        <>
          <FormGroup>
            <Grid container spacing={2}>
              {togglableColumns.map((c, index) => {
                const isDisabled = togglableColumns && togglableColumns?.length <= 1 && (c.visible ?? true);
                return (
                  <Grid item xs={12} md={columnSize} key={index}>
                    <FormControlLabel
                      key={"edit-column-label-" + index}
                      control={
                        <Checkbox
                          key={"edit-column-checkbox-" + index}
                          defaultChecked={c.visible ?? true}
                          onChange={onCheckboxChange}
                          value={c.title}
                          aria-label={`column checkbox ${c.title}`}
                          disabled={isDisabled}
                          inputProps={{ "data-column-type": c.type } as CheckboxProps["inputProps"]}
                        />
                      }
                      label={c.title}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </FormGroup>
        </>
      }
      footerContent={<></>}
      dataTestId="edit-table-columns"
      handleCloseModal={handleModalClose}
      isOpen={isOpen}
    />
  );
}

const filterColumns = (cols: KaColumn[]) => {
  return cols.filter((c) => c.key !== "actions" && c.key !== "selection-cell");
};
